import { Button } from '@hausgold/designsystem';
import { map } from 'lodash-es';
import { useContext, Fragment } from 'react';
import { ApiContext, WizardContext } from '../utils/contexts.js';
import FluidMaxContainer from '../components/FluidMaxContainer.js';
import WizardCard from '../components/WizardCard.js';
import { getLineKeys, getHeadingText, getStepKeys, getLineTitle, getLineIcon, getLineIconSVG } from '../services/models/dialog.js';
import { jsx } from '@emotion/react';
var Start = function Start() {
  var _useContext = useContext(ApiContext),
    data = _useContext.data;
  var _useContext2 = useContext(WizardContext),
    position = _useContext2.position,
    setCurrentLine = _useContext2.setCurrentLine,
    setCurrentStep = _useContext2.setCurrentStep,
    _useContext2$componen = _useContext2.components,
    WizardHeading = _useContext2$componen.WizardHeading,
    StartLayoutContainer = _useContext2$componen.StartLayoutContainer,
    CustomNavigationButtonsStart = _useContext2$componen.CustomNavigationButtonsStart,
    ChoiceOptionColContainer = _useContext2$componen.ChoiceOptionColContainer,
    ChoiceOptionRowContainer = _useContext2$componen.ChoiceOptionRowContainer,
    CustomWizardCard = _useContext2$componen.CustomWizardCard;
  var lines = getLineKeys(data);
  return jsx(Fragment, null, jsx(WizardHeading, null, getHeadingText(data)), jsx(FluidMaxContainer, null, jsx(StartLayoutContainer, null, jsx(ChoiceOptionRowContainer, null, map(lines, function (key) {
    return jsx(ChoiceOptionColContainer, {
      key: key,
      position: position,
      context: "start"
    }, jsx(Button, {
      as: "a",
      variant: "unstyled",
      role: "link",
      onClick: function onClick() {
        var _window;
        var firstStep = getStepKeys(data, key)[0];
        var chosenLine = key;

        // Track user progress
        (_window = window) === null || _window === void 0 || (_window = _window.analytics) === null || _window === void 0 || _window.track("".concat(chosenLine, "-clickto_step", 1, "_").concat(firstStep), {
          label: getLineTitle(data, key),
          category: 'formwizard'
        });

        // Set chosen line
        setCurrentLine(chosenLine);

        // Set current step
        setCurrentStep(firstStep);
      }
    }, CustomWizardCard ? jsx(CustomWizardCard, {
      iconId: getLineIcon(data, key),
      iconSvg: getLineIconSVG(data, key),
      title: getLineTitle(data, key)
    }) : jsx(WizardCard, {
      iconId: getLineIcon(data, key),
      iconSvg: getLineIconSVG(data, key),
      title: getLineTitle(data, key)
    })));
  })), CustomNavigationButtonsStart && jsx(CustomNavigationButtonsStart, null))));
};
export { Start as default };